// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h50Ic","type":"styles_type__11rgO","choices":"styles_choices__1Nh8A"};